import RecruitApiClient from '../../RecruitApiClient';
import { IActivity, ICreateCandidateTaskParams, IGetCandidateApplicationsParams } from './types';

class Api {
  getCandidateData = (candidateId: number) =>
    RecruitApiClient.get(`/api/v4/candidates/${candidateId}`, null);
  updateCandidateTags = (candidateId: number, tags: string[]) =>
    RecruitApiClient.post(`/api/v4/candidates/${candidateId}/update_tags`, {
      tags
    });
  getCandidateApplications = (candidateId: number, params: IGetCandidateApplicationsParams) =>
    RecruitApiClient.get(`/api/v4/candidates/${candidateId}/applications`, params);
  getCandidateTasks = (candidateId: number) =>
    RecruitApiClient.get(`/api/v4/candidates/${candidateId}/tasks`);
  getAssignableUsers = () => RecruitApiClient.get(`/api/v4/tasks/assignable_users`);
  createCandidateTask = (candidateId: number, params: ICreateCandidateTaskParams) =>
    RecruitApiClient.post(`/api/v4/candidates/${candidateId}/tasks`, params);
  deleteCandidateTask = (candidateId: number, taskId: number) =>
    RecruitApiClient.delete(`/api/v4/candidates/${candidateId}/tasks/${taskId}`);
  updateCandidateTask = (candidateId: number, taskId: number, params: ICreateCandidateTaskParams) =>
    RecruitApiClient.put(`/api/v4/candidates/${candidateId}/tasks/${taskId}`, params);
  getWorkflows = (candidateId: number) =>
    RecruitApiClient.get(`/api/v4/workflows?candidate_id=${candidateId}`);
  assignWorkflow = (candidateId: number, params: { id: number; user_id: number }) =>
    RecruitApiClient.post(`/api/v4/workflows?candidate_id=${candidateId}`, params);
  getCandidateActivities = (candidateId: number): Promise<{ res: { activities: IActivity[] } }> =>
    RecruitApiClient.get(`/api/v4/candidates/${candidateId}/activities`);
  addCandidateNote = (candidateId: number, params: { subject: string; body: string }) =>
    RecruitApiClient.post(`/api/v4/candidates/${candidateId}/add_permanent_record`, {
      note: params
    });
  mergeCandidates = (candidateId: number) =>
    RecruitApiClient.post(`/api/v4/candidates/${candidateId}/merge`);
  updateCandidateNotepad = (
    candidateId: number,
    body: string
  ): Promise<{ res: { success: string } }> =>
    RecruitApiClient.put(`/api/v4/candidates/${candidateId}/update_notepad`, { body });
}

export default new Api();
